<template>
  <v-container fill-height fluid>
    <v-card
      elevation="4"
      :width="this.$vuetify.breakpoint.xsAndDown ? '100%' : '644px'"
      class="mx-auto"
    >
      <v-card-title>{{ $t('settings') }}</v-card-title>

      <v-card-text>
        <div v-if="loadingPermissions" class="settings-state">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <v-list v-else-if="hasSettingsAccess" nav>
          <v-list-item-group color="secondary">
            <v-list-item
              v-for="item in availableMenuItems"
              :key="item.title"
              :to="getDestinationObj(item)"
              class="settings-list-item"
            >
              <v-list-item-icon>
                <v-icon class="pl-3" color="secondary" v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="$t(item.title)"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <div v-else class="settings-state settings-state--inactive">
          {{ $t('inactive_settings') }}
        </div>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<style scoped>
  .settings-list-item {
    background-color: var(--v-primary-base);
    margin-bottom: 15px !important;
    height: 50px;
    font-weight: 600;
  }

  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: var(--v-secondary-base) !important;
  }

  .settings-list-item > .v-list-item__icon > i {
    font-size: 1.75rem;
    height: 18px;
  }

  .v-list-item--active::before {
    opacity: 0;
  }

  .settings-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
  }

  .settings-state--inactive {
    color: rgba(0, 0, 0, 0.6);
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
  }
</style>

<script>

import { mapState } from 'vuex'
import AclAPI from '@/services/api/business/acl'
import UserRoles from '@/store/core/user/user-roles'

const EDIT_ACCESS_LEVEL = 4

export default {
  name: "DeliverableSettings",

  data() {
    return {
      loadingPermissions: true,
      userAcl: 0,
    }
  },

  computed: {
    ...mapState({
      userRoles: state => state.core.auth.userRoles,
      menuItems: state => state.app.deliverableSettingsItems,
    }),

    hasAdminAccess() {
      return this.userRoles.includes(UserRoles.USER_ADMIN) || this.userRoles.includes(UserRoles.USER_MASTER)
    },

    hasEditAclAccess() {
      return (this.userAcl & EDIT_ACCESS_LEVEL) !== 0
    },

    hasSettingsAccess() {
      return this.hasAdminAccess || this.hasEditAclAccess
    },

    availableMenuItems() {
      if (!this.hasSettingsAccess) return []
      return this.menuItems || []
    },
  },

  mounted() {
    this.loadPermissions()
  },

  methods:{
    async loadPermissions() {
      this.loadingPermissions = true

      try {
        const result = await AclAPI.getMyAcls()
        const aclItems = result.data.items || result.data || []
        const acls = Array.isArray(aclItems) ? aclItems : [aclItems]

        this.userAcl = acls.reduce((combined, acl) => {
          return combined | (acl.access_level || 0)
        }, 0)
      } catch (error) {
        console.error('Error loading user ACLs:', error)
        this.userAcl = 0
      } finally {
        this.loadingPermissions = false
      }
    },

    getDestinationObj(item) {
      return {
        name: item.routeName,
      }
    }
  },
}

</script>
